import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';

enum Bingo50PrizeType {
    Jackpot = 'jackpot',
    HousePrize = 'houseprize',
    LinePrize = 'lineprize'
}

function getPrizeTypeName(prizeType: Bingo50PrizeType) {
    switch (prizeType) {
      case Bingo50PrizeType.HousePrize:
        return 'House Prize';
      case Bingo50PrizeType.Jackpot:
        return 'Jackpot';
      case Bingo50PrizeType.LinePrize:
        return 'Line Prize';
    }
}

function getPrizeStages(): DefaultStageElement[] {
  return [
      { name: getPrizeTypeName(Bingo50PrizeType.LinePrize), stage: 1 },
      { name: getPrizeTypeName(Bingo50PrizeType.HousePrize), stage: 3 },
      { name: getPrizeTypeName(Bingo50PrizeType.Jackpot), stage: 4 }
  ];
}

export { Bingo50PrizeType, getPrizeTypeName, getPrizeStages };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-50/_domain/models/prize-type.ts